import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {CustomersPage} from '../../../customers/customers-page'

export const Route = createFileRoute('/_app/customers/')({
    component: CustomersRoute,
})

function CustomersRoute() {
    return (
        <Container size="lg" py="xl">
            <CustomersPage />
        </Container>
    )
}
